import React, { useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import JS files

// import others files
import useFetch from "../../../context/useFetch";
import { useNavigate } from "react-router-dom";

const ImgList = (props) => {
  const navigate = useNavigate();

  const [newsList, setNewsList] = useState([]);
  const getCompaniesListApi = useFetch({
    method: "get",
    url: "News_Service/get_insurance_news",
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setNewsList(res);
    },
  });
  return (
    <>
      <div className="flex justify-between items-center p-4  bg-myblues-300 rounded-t-lg md:h-[4rem]">
        <span className="text-sm md:text-base font-bold text-white">
          اخبار شرکت‌ها
        </span>
        <div
          className="flex items-center text-xs md:text-sm text-white cursor-pointer transition-all hover:scale-105"
          onClick={() => navigate(`/news-list/company`)}
        >
          <span>مشاهده همه</span>
          <ArrowBackIosIcon fontSize="1rem" />
        </div>
      </div>
      <ul className="overflow-auto h-[24rem] md:h-[28rem] p-4 bg-mygrays-100 rounded-b-lg hide-scroll">
        {newsList.map((item, index) => {
          return (
            <li
              className=" text-myblacks-300 transition-all hover:text-myblues-300 cursor-pointer grid grid-cols-12 gap-4 items-center  border-b border-white last:border-b-0 my-4 pb-4 last:pb-0"
              onClick={() => navigate(`/news-content/${item.id}`)}
            >
              <div className="col-span-3 md:col-span-2">
                <div className="bg-white rounded-lg p-1 flex justify-center items-center">
                  <img src={item.insurance_logo.logo} className="w-12 h-12" />
                </div>
              </div>
              <div className="col-span-9 md:col-span-10 leading-7 ">
                <span className="text-xs md:text-sm font-bold">
                  {item.news_detail[0].header}
                </span>
              </div>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default ImgList;
